import PropTypes from 'react-proptypes';
import ToolLogoSvg from 'images/topafslag/logo.svg';

export default {
  app: 'topafslag',
  framed: false,
  logo: ToolLogoSvg,
  pages: ['landing', 'original-situation', 'current-situation', 'final'],
  syncing: false,
  broken: false,
  recalculating: null,
  settings: null,
  input: {
    mortgage_provider_id: null,
    mortgage_provider_label: null,
    has_nhg: false,
    original_mortgage_amount: null,
    original_house_value: null,
    current_mortgage_amount: null,
    current_house_value: null,
  },
  output: {
    errors: {},
  },
};

// It is not possible to send objects as url params
// so only add variables that have primitive values
export const whiteListUrlParams = [
  'has_nhg',
  'original_mortgage_amount',
  'original_house_value',
  'current_mortgage_amount',
  'current_house_value',
];

const { number, string, bool, shape, instanceOf } = PropTypes;

export const shapeSettings = shape({
  leadButtonUrl: string,
  leadButtonText: string,
  showLeadButton: bool,
  leadFormHeader: string,
  leadFormText: string,
  mortgage_providers: instanceOf(Array),
});

export const shapeInput = shape({
  original_mortgage_amount: number,
  original_house_value: number,
  current_mortgage_amount: number,
  current_house_value: number,
});

export const shapeOutput = shape({});
